import { useEffect, useRef } from 'react';
import { getFramework, useIdentity } from '@/framework';
import { DirectionType, ILayerProps, IPoint } from '@/version-types';
import { CropStagePlugin } from '../../controller';

const MouseScaleAction: React.FC<{ stageScale: number }> = ({ children, stageScale }) => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const nodeRef = useRef<HTMLDivElement>(null);
    const wheelY = useRef<number>(0);
    const originIndex = framework.stage.getActiveOriginIndex();
    const getLayers = () => framework.getLayers(originIndex);
    const getMainLayer = () => framework.getMainLayer(originIndex)!;
    const cropController = framework.getInstance(CropStagePlugin);
    const isZooming = useRef(false); // 是否正在缩放
    const zoomEndTimer = useRef<NodeJS.Timeout | null>(null); // 定时器
    const currentMousePointRef = useRef<IPoint>({ x: 0, y: 0 });
    const scaleDistanceRef = useRef<number>(0);
    const originMainLayer = useRef<ILayerProps | null>(null);
    const originLayers = useRef<ILayerProps[] | null>(null);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            currentMousePointRef.current = { x: e.clientX, y: e.clientY };
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    useEffect(() => {
        const mouseWheelHandle = (ev) => {
            // const isScaleKeyDown = ev.ctrlKey || checkScaleKeydown();
            // if (!isScaleKeyDown) return;
            ev.preventDefault();
            ev.stopPropagation();
            wheelY.current += ev.deltaY;

            if (Math.abs(wheelY.current) >= 2) {
                if (ev.deltaY > 0) {
                    wheelY.current = 0;
                    scaleDistanceRef.current = scaleDistanceRef.current - 1;
                } else if (ev.deltaY < 0) {
                    wheelY.current = 0;
                    scaleDistanceRef.current = scaleDistanceRef.current + 1;
                }

                if (!originMainLayer.current || !originLayers.current) {
                    originMainLayer.current = getMainLayer();
                    originLayers.current = getLayers();
                }

                // TODO 还要一个 如果已经达到最大或者最小了就不让移了
                cropController.scaleMainLayerOperate(
                    originMainLayer.current,
                    originLayers.current,
                    scaleDistanceRef.current > 0 ? DirectionType.POSITIVE : DirectionType.OPPOSITE,
                    currentMousePointRef.current,
                    stageScale,
                    scaleDistanceRef.current,
                );
            }

            // 标记为正在缩放
            isZooming.current = true;

            // 清除之前的定时器
            if (zoomEndTimer.current) clearTimeout(zoomEndTimer.current);

            // 设置新定时器：停止缩放后触发回调
            zoomEndTimer.current = setTimeout(() => {
                isZooming.current = false;
                console.log('双指缩放已停止');
                scaleDistanceRef.current = 0;
                originMainLayer.current = null;
                originLayers.current = null;
                // 在此执行缩放停止后的操作
            }, 300); // 200ms 内无新事件视为停止
        };
        nodeRef.current?.addEventListener('wheel', mouseWheelHandle);
        return () => {
            nodeRef.current?.removeEventListener('wheel', mouseWheelHandle);
        };
    }, [stageScale]);

    return (
        <div ref={nodeRef} style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
            {children}
        </div>
    );
};

export default MouseScaleAction;
